<template>
    <div class="body">
        <p  class="p1" style="padding-top: 8vh;">🚀 志向高远，心之所向</p>

        <p class="p5">以踏实的努力应对检验，</p>
        <p class="p6">在挑战中前行，步步攀高峰。</p>
        <div v-if="ReportData.examTimes">
            <p class="p6" style="padding-top: 4vh;">今年你在富学宝典上累计考试<a class="highlight">{{ ReportData.examTimes }}</a>次</p>
            <p class="p6">其中一次通过考试的课程有<a class="highlight">{{ ReportData.coursenumF }}</a>门</p>
            <p class="p6">超越了<a class="highlight">{{ ReportData.rate4 }}</a>%的小伙伴！</p>
        </div>
        <div v-if="ReportData.lesson">
            <p class="p6" style="padding-top: 5vh;">2025年你的线下授课时数共计<a class="highlight">{{ totalHours }}</a>小时：</p>
            <p class="p6" style="padding-top: 2vh;"  v-for="(char, index) in lessonArray" :key="index">
                <a class="highlight">{{ char.class_type }}</a>类课程
                <span v-show="char.class_num!==0"><a class="highlight">{{ char.class_num }}</a>门</span>
                <span v-show="char.hours!==0"><a class="highlight">{{ char.hours }}</a>小时</span>
                <span v-show="char.student_num!==0">，<a  class="highlight">{{ char.student_num }}</a>人参与</span>
            </p>
        </div>
    </div>
</template>
  
<script>
import * as echarts from 'echarts';
export default {
    props: [ "ReportData"],
    data(){
        return{
            lessonArray:[],
            totalHours:0,
            classType:'',
            sutdentNum:0,
        }
    },
    created() {
       // 先清零，防止重复累加
        this.totalHours = 0;

        if (this.ReportData.lesson) {
        try {
            const parsed = JSON.parse(this.ReportData.lesson);
            this.lessonArray = Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            console.error('lesson JSON 解析失败', e);
            this.lessonArray = [];
        }

        this.lessonArray.forEach(item => {
            const hours = Number(item.hours);
            if (!isNaN(hours)) {
                this.totalHours += hours;
            }
        });
        } else {
            this.lessonArray = [];
        }

    }
}
</script>

<style scoped>
.body {
    background: url("../../assets/25October/logo.png") right  top  no-repeat,
                /* url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat, */
                url("../../assets/25Year/bg.png")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 18px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
    font-size: 28px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
 
  .p5, .p6, .p7, .p8{
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 16px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }

  .p5, .p7{
    margin-top: 20px;
  }
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25Year/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .p1,.p2, .p3, .p4 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 25px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .highlight {
    font-size: 38px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    margin:0 auto;
    text-align: center;
    font-size: 20px;
    width: 92%;
  }

  .p5, .p7{
    margin-top: 20px;
  }
}
</style>